<template>
  <div class="shipment-filters">
    <div class="from-to-filter">
      <div class="mb-4">
        <mc-typeahead
          id="typeaheadFrom"
          ref="from"
          :label="$t('filter.from')"
          icon="pin"
          :value.prop="selectedFromLocation ? selectedFromLocation.label : null"
          :data="fromLocations"
          :loading="fromLocationsLoading"
          :clearbutton="true"
          minchars="3"
          maxoptions="15"
          @search="searchFromLocations"
          @optionselected="setFromLocation"
        />
      </div>
      <div>
        <mc-typeahead
          id="typeaheadTo"
          ref="to"
          :label="$t('filter.to')"
          icon="pin"
          :value.prop="selectedToLocation ? selectedToLocation.label : null"
          :loading="toLocationsLoading"
          :data="toLocations"
          :clearbutton="true"
          minchars="3"
          maxoptions="15"
          @search="searchToLocations"
          @optionselected="setToLocation"
        />
      </div>
    </div>
    <div class="vessel-filter">
      <mc-typeahead
        id="typeaheadVessel"
        ref="vessel"
        minchars="0"
        :label="$t('filter.vesselName')"
        :value.prop="selectedVessel ? selectedVessel.label : null"
        :data="vessels"
        maxoptions="15"
        :clearbutton="true"
        @optionselected="setVessel"
      />
    </div>
    <div class="role-filter">
      <mc-select
        ref="role"
        name="role-filter"
        :value.prop="selectedRole"
        :label="$t('filter.role')"
        @optionselected="setRole"
      >
        <mc-option v-for="role in roles" :key="role.id" :value="role.value" :label="role.label" />
      </mc-select>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "pinia";
import { filters } from "@/store/filters";
import emitter from "tiny-emitter/instance";
import { getExportImportPage } from "@/lib/utilities";

export default {
  name: "ShipmentFilters",
  data() {
    return {
      fromLocationsLoading: false,
      toLocationsLoading: false
    };
  },
  computed: {
    ...mapState(filters, [
      "fromLocations",
      "toLocations",
      "vessels",
      "roles",
      "selectedVessel",
      "selectedFromLocation",
      "selectedToLocation",
      "selectedRole"
    ])
  },
  async mounted() {
    emitter.on("save-filter", this.openSaveFilter);
  },
  methods: {
    ...mapActions(filters, [
      "getFromLocations",
      "getToLocations",
      "updateFromLocation",
      "updateToLocation",
      "updateRole",
      "updateVessel"
    ]),
    async searchFromLocations($event) {
      const searchTerm = $event.target.value;
      if (searchTerm.length > 2) {
        this.fromLocationsLoading = true;
        await this.getFromLocations(searchTerm);
        this.fromLocationsLoading = false;
      }
    },
    async searchToLocations($event) {
      const searchTerm = $event.target.value;
      if (searchTerm.length > 2) {
        this.toLocationsLoading = true;
        await this.getToLocations(searchTerm);
        this.toLocationsLoading = false;
      }
    },
    setFromLocation($event) {
      this.updateFromLocation($event?.detail);
      this.logDDEvent();
    },
    setToLocation($event) {
      this.updateToLocation($event?.detail);
      this.logDDEvent();
    },
    setVessel($event) {
      this.updateVessel($event?.detail);
      this.logDDEvent();
    },
    setRole($event) {
      this.updateRole($event?.target?.selectedOption);
      this.logDDEvent();
    },
    logDDEvent() {
      this.$sendGAEvent({
        event: "DQCS",
        action: "Click",
        category: "SO_AdhocFilter",
        label: { data: "AdhocFilter", page: getExportImportPage() === "IMP" ? "Import" : "Export" }
      });
    },
    openSaveFilter() {
      emitter.emit("save-filter-modal-desktop", true);
    }
  }
};
</script>
